<template>
  <a :href="event.path" class="list-group-item list-group-item-action event-list-item">
    <div class="d-flex">
      <time class="event-date" :datetime="event.start_date">
        <span class="event-date__month">{{ event.start_month }}</span>
        <span class="event-date__day">{{ event.start_day }}</span>
        <span class="event-date__year">{{ event.start_year }}</span>
      </time>
      <div class="event-list-item__content">
        <h4 class="event-list-item__title">
          {{ event.name }}
          <span class="event-list-item__distances">
            <span
              v-for="race in event.races"
              :key="race.name"
              class="badge badge-secondary mr-1"
            >
              {{ race.name }}
            </span>
          </span>
        </h4>
        <p class="event-list-item__details mb-0">
          <strong>{{ event.location }}</strong>
          <template v-if="multiDay">
            <span class="event-list-item__sep">&middot;</span>
            <span>{{ event.display_date_range }}</span>
          </template>
          <template v-if="event.organization">
            <span class="event-list-item__sep">&middot;</span>
            <span class="text-muted">{{ event.organization }}</span>
          </template>
        </p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: ['event'],

  computed: {
    // The date tile carries the start date, so repeating it in the details
    // line only adds noise. A multi-day event still needs the full range,
    // since the tile can only show where it starts.
    multiDay() {
      const { start_date: start, end_date: end } = this.event;
      return Boolean(start && end && start !== end);
    }
  }
};
</script>

<style scoped>
.event-list-item {
  padding: 1rem;
  transition: background-color 0.15s ease-in-out;
}

.event-list-item:hover {
  background-color: #f8f9fa;
}

/* Calendar tile: month band, day, year — the day is what a race-goer scans
   for, so it gets the size, and the tile keeps every row aligned. */
.event-date {
  flex: 0 0 3.5rem;
  align-self: flex-start;
  margin-right: 1rem;
  border: 1px solid #e9ecef;
  border-radius: 0.35rem;
  background-color: #fff;
  overflow: hidden;
  text-align: center;
  line-height: 1;
}

.event-date__month {
  display: block;
  padding: 0.25rem 0;
  background-color: #212529;
  color: #fff;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.event-date__day {
  display: block;
  padding-top: 0.3rem;
  color: #212529;
  font-size: 1.5rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.event-date__year {
  display: block;
  padding: 0.15rem 0 0.35rem;
  color: #868e96;
  font-size: 0.6875rem;
  font-variant-numeric: tabular-nums;
}

.event-list-item__content {
  flex: 1;
  min-width: 0;
}

.event-list-item__title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: #212529;
}

.event-list-item__distances {
  font-size: 0.75rem;
}

.event-list-item__distances .badge {
  font-weight: 500;
  padding: 0.25em 0.5em;
  background-color: #212529;
  color: #fff;
}

.event-list-item__details {
  font-size: 0.875rem;
  color: #495057;
}

.event-list-item__sep {
  margin: 0 0.4rem;
  color: #adb5bd;
}
</style>
